import React from "react";

/* eslint-disable max-len */
export default function CommentCountIcon() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 32 30.5" enableBackground="new 0 0 32 30.5" xmlSpace="preserve">
		<path fill="#AAAAAA" d="M27.4,1.3H4.6c-1.6,0-2.8,1.3-2.8,2.8l0,25.6L7.5,24h19.9c1.6,0,2.8-1.3,2.8-2.8V4.1
			C30.2,2.6,28.9,1.3,27.4,1.3z M11.7,14.1H8.9v-2.8h2.8V14.1z M17.4,14.1h-2.8v-2.8h2.8V14.1z M23.1,14.1h-2.8v-2.8h2.8V14.1z"/>
		</svg>
    );
}
